import { Loading } from 'element-ui'

const YLoading = Loading

export default YLoading
